import moment from 'moment';
import { formatTimestampToValueDate } from './formatTimestampToValueDate';
import { formatValueDateToMoment } from './formatValueDateToMoment';
import { timing } from '@morf/proto/timing/v1/timing_ts_proto';
import { values } from '@morf/proto/values/v1/values_ts_proto';

export const filterSlotByValueDate = (
  slot: timing.v1.Timestamp,
  date: values.v1.Date
): boolean => {
  const slotDate = formatTimestampToValueDate(slot);
  const slotMoment = formatValueDateToMoment(slotDate);
  const dateMoment = formatValueDateToMoment(date);
  return moment(slotMoment).isSame(dateMoment, 'day');
};
